<template>
  <div class="content">
    <!-- Dialog DELETE  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="deleteDialog"
      max-width="450px"
    >
      <DeleteModal
        :quantidade="this.quantAttributeProduct"
        title="Deletar"
        textMessage="Tem certeza que deseja deletar este atributo?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation=""
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- NEW ATTRIBUTE  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newAttributeDialog"
      max-width="840px"
    >
      <NewAttribute
        :attribute="this.currentAttribute"
        v-if="newAttributeDialog"
        :textMessage="''"
        @action="newAttributeDialog = true"
        @close="(newAttributeDialog = false), updateTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="removeSubcategories()"
      />
    </v-dialog>

    <v-dialog
        v-model="confirmActionRecordCannotDeleteModalDialog"
        max-width="700"
    >
      <RecordCannotDeleteModal
          :recordsCannotDelete="recordsCannotDelete"
          :title="titleRecordsCannotDelete"
          @close="(confirmActionRecordCannotDeleteModalDialog = false)"
      />
    </v-dialog>

    <v-card class="filter-card mt-0 mb-6" elevation="0">
      <v-row class="pa-0 ma-0 mn-4">
        <v-col cols="12">
          <span class="filter-text">
            Cadastre os atributos que serão visiveis para cadastro de produtos. Edite e
            delete atributos existentes.
          </span>
        </v-col>
        <v-col
          class="d-flex flex-column align-start my-1 py-1"
          cols="12"
          lg="6"
          md="6"
          sm="6"
        >
          <v-text-field
            outlined
            hide-details
            style="
              border: 1px solid #979797;
              border-radius: 7.5px;
              width: 100%!important;
              margin-bottom: 16px;
            "
            color="black"
            background-color="#F5F5F5"
            placeholder="Seletor ou nome"
            v-model="filter.name"
            v-on:keyup="filterTable"
            :loading="loading"
          >
            <template v-slot:append>
              <v-icon class="pt-0" color="normalred" size="26">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col
          class="d-flex flex-row justify-center my-1 py-1"
          cols="12"
          lg="3"
          md="3"
          sm="3"
        >
          <v-btn
            height="56"
            outlined
            elevation="0"
            class="reset-button mr-2"
            style="border: 1px solid; box-sizing: border-box; border-radius: 7.5px"
            @click="reset"
            width="100%"
            :loading="loading"
          >
            <span> Limpar Filtros</span>
          </v-btn>
        </v-col>

        <v-col
          class="d-flex flex-row justify-center my-1 py-1"
          cols="12"
          lg="3"
          md="3"
          sm="3"
        >
          <v-btn
            block
            class="mr-2 add-button"
            height="56"
            elevation="0"
            color="normalred"
            style="border-radius: 7.5px"
            width="100%"
            @click="
              currentAttribute = {};
              newAttributeDialog = true;
            "
          >
            <span>Novo atributo</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-data-table
      id="attribute-table"
      :loading="loading"
      loading-text="Carregando..."
      no-data-text="Nenhum atributo encontrada"
      :headers="headers"
      :items="attributes"
      class="elevation-0"
      hide-default-footer
      :items-per-page="pageSize"
      :header-props="headerProps"
      v-model="selectedAttributes"
      show-select
      item-key="id"
      :single-select="false"
    >
      <template v-slot:[`header.actions`]="{ header }">
        <span style="padding-right: 20px"> {{ header.text }}</span>
      </template>

      <template v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 4px"
              width="35"
              height="35"
              small
              class="edit-button"
              color="quaternary"
              @click="editAttribute(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 4px"
              width="35"
              height="35"
              small
              class="remove-button ml-2"
              color="red"
              @click="deleteAttribute(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </template>

      <template v-slot:header.data-table-select="{ on, props}">
        <v-simple-checkbox
            color="#bc0000"
            v-bind="props"
            v-on="on"
            :ripple="false"
        >
        </v-simple-checkbox>
      </template>

      <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
        <v-simple-checkbox
            :ripple="false"
            @click="addAttributeListSelectedAttributes(item)"
            :value="isSelected"
            color="#bc0000"
            v-bind="props"
            v-on="on"
        >
        </v-simple-checkbox>
      </template>

      <template v-slot:footer >
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>

        <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedAttributes.length > 0">
          <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
            <label>Selecione a ação</label>
            <v-select
                class="ma-0 pa-0 "
                dense
                v-model="actionSelected"
                outlined
                style="border-radius: 3px!important"
                :items="actions"
                item-text="label"
                item-value="value"
                placeholder="Selecione a ação"
            >
            </v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
            <v-btn
                class="secondary-button mt-5 ml-3"
                style="height: 40px!important; border-radius: 7.5px!important"
                height="40"
                width="100%"
                elevation="0"
                :disabled="!actionSelected"
                @click="confirmActionDialog = true"
            >
              {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.content {
  background: #e5e5e5;
}

.filter-card {
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
  border-radius: 6px;
}

.filter-text {
  font-weight: 300;
  font-size: 20px;
  line-height: 35px;
  color: #9c9c9c;
}

.add-button {
  background: #bc0000;
  border-radius: 10px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
  transition: 0.3s;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.reset-button {
  border-radius: 10px;
  transition: 0.3s;
}

.reset-button:hover {
  color: #fff;
  background: #000000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.edit-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: bold;
  transition: 300ms;
}

.edit-button:hover {
  background: #2d3038;
  color: white !important;
}

.edit-button:focus {
  background: #444854;
  color: white !important;
}

.remove-button {
  border: 2px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}
</style>

<script>
import ApiService from "../../../../../services/ApiService";
import DeleteModal from "../../../components/DeleteModal.vue";
import NewAttribute from "../components/newAttribute.vue";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import RecordCannotDeleteModal from "@/views/pages/components/RecordCannotDeleteModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  props: {
    title: String,
    attribute: Object,
    filtro: Object,
  },

  components: {
    RecordCannotDeleteModal, ConfirmModal,
    Pagination,
    NewAttribute,
    DeleteModal,
  },
  data: () => ({
    recordsCannotDelete: [],
    titleRecordsCannotDelete: "",
    selectedAttributes: [],
    actions: [
      { label: "Excluir atributo(s)", value: 1},
    ],
    actionSelected: null,
    confirmActionRecordCannotDeleteModalDialog: false,
    confirmActionDialog: false,
    quantAttributeProduct: 0,
    newAttributeDialog: false,
    deleteDialog: false,
    closeNoLoading: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    attributes: [],
    currentAttribute: {},
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 15,
    btnColor: "",
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
    },
    error: false,
    show: false,
    message: "",
    headers: [
      { text: "Nome", align: "start", class: "item", value: "name" },
      {
        text: "Tipo",
        class: "item",
        value: "type",
        align: "center",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "end",
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  computed: {},

  async created() {
    await this.updatePageView();
  },

  methods: {
    removeSubcategories(){
      try {
        this.recordsCannotDelete = [];
        this.confirmActionDialog = false;
        this.selectedAttributes.forEach((attribute) => {
          const itens = []
          if (attribute.groupAttributes && attribute.groupAttributes.length > 0) {
            itens.push('Atributo está relacionada a grupos de atirbuto')
          }
          if (attribute.skusAttributes && attribute.skusAttributes.length > 0) {
            itens.push('Atributo está relacionada a skus')
          }

          if (itens.length > 0){
            this.recordsCannotDelete.push(
                {
                  subTitle: `Atributo: <strong>${attribute.name}</strong>`,
                  motives: itens,
                }
            )
          }
        })

        if (this.recordsCannotDelete.length > 0) {
          this.confirmActionRecordCannotDeleteModalDialog = true
          this.confirmActionDialog = false
          this.titleRecordsCannotDelete = `Atributos que não podem serem excluídos`
          return
        }

        this.apiService
            .post("attribute/delete/list", this.selectedAttributes)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Atributos excluídos com sucesso.",
                trace: null,
              });
              this.confirmActionDialog = false
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível excluir os cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {

      }
    },

    addAttributeListSelectedAttributes(attribute){
      const attributeFind = this.selectedAttributes.findIndex((x) => x.id === attribute.id)
      if (attributeFind > -1) {
        this.selectedAttributes.splice(attributeFind, 1)
      } else {
        this.selectedAttributes.push(attribute)
      }
    },

    async updatePageView() {
      await this.updateTable();
    },

    editAttribute(item) {
      this.currentAttribute = item;
      this.newAttributeDialog = true;
    },

    async deleteAttribute(item) {
      this.currentAttribute = item;
      await this.apiService
        .get(`attribute/listByAttribute/${this.currentAttribute.id}`)
        .then((response) => {
          this.quantAttributeProduct = response.length;
        })
        .catch(() => {});

      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`attribute/delete`, this.currentAttribute)
        .then(() => {
          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch(() => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    action() {
      this.$emit("action");
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`attribute/list`, this.filter)
        .then((response) => {
          this.attributes = response.attributes;
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    close() {
      this.$emit("close");
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 15,
      };
      this.page = 1;
      this.updateTable();
    },

    filterTable() {
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      this.updateTable();
    },
  },

  watch: { },
};
</script>
